import { getEngineImageOverridesFromEnvironment } from "./engine-image-overrides";
import type { EngineImageOverride, EngineImageOverrideResult } from "./engine-image-overrides";
import { useDANGEROUSisChalkEmployee } from "../use-is-chalk-employee";
import { useRouteAndTeamInfo } from "../url/use-route-info";
export type { EngineImageOverride, EngineImageOverrideResult } from "./engine-image-overrides";

/**
 * Hook to check if the current environment has any engine image overrides
 * or pinned base images, and collect all override details.
 *
 * Only checks if the user is a Chalk employee to avoid unnecessary processing.
 *
 * @returns Object containing hasOverride boolean and array of all overrides
 */
export function useHasEngineImageOverride(): EngineImageOverrideResult {
  const isChalkEmployee = useDANGEROUSisChalkEmployee({ ignoreAdminMode: true });
  const { environment } = useRouteAndTeamInfo();

  // Early return if not a Chalk employee - don't process environment data
  if (!isChalkEmployee) {
    return { hasOverride: false, overrides: [] };
  }

  if (!environment) {
    return { hasOverride: false, overrides: [] };
  }

  const overrides: EngineImageOverride[] = getEngineImageOverridesFromEnvironment(environment);

  return {
    hasOverride: overrides.length > 0,
    overrides,
  };
}
